import React from 'react';
import { motion } from 'framer-motion';
import onibus from '../../img/veiculo/bus.jpeg';
import embarcacao from '../../img/veiculo/embarcacao.WEBP';
import ReactTooltip from 'react-tooltip';

function ImageGrid({ setSelectedImg, veiculo, tipoVeiculo }) {  
  let imagemVeiculo;  
  if (tipoVeiculo)  {
    if (tipoVeiculo == 'EMBARCACAO') {
      imagemVeiculo = veiculo ? veiculo.urlImagem : embarcacao;
    } else {
      imagemVeiculo = veiculo ? veiculo.urlImagem : onibus; 
    } 
  } else {
    imagemVeiculo = veiculo ? veiculo.urlImagem : onibus; 
  }

  
  return (
    <div className="img-grid">
      <div>
        <span className="align-self-center tooltip-info">
          <div className="tooltip-ut">
            <ReactTooltip className="tooltip-ut" id={imagemVeiculo}
              type="dark" effect="solid">
              <div className="row">Clique para expandir.</div>
            </ReactTooltip>
          </div>
        </span>
        <motion.div
          layout
          className="img-wrap profile"
          data-toggle="tooltip"
          data-tip
          data-for={imagemVeiculo}
          key={imagemVeiculo}
          style={{ cursor: 'pointer' }}
          onClick={() => setSelectedImg(imagemVeiculo)}
        >
          <motion.img
            src={imagemVeiculo}
            alt={imagemVeiculo}
          />
        </motion.div><br />
      </div>
    </div>
  );
}

export default ImageGrid;
